module.exports = __webpack_public_path__ + "img/welcomes-preview-current-all.93acd2e0.png";